export default {
  dealers: {
    title: "Dealers",
    fields: {},
  },
};
